__turbopack_context__.v({
  "label": "styles-module-scss-module__c1SCCa__label",
});
